import { useEffect } from 'react'

const useAnimation = () => {
    useEffect(() => {
        const elements = [
            ...document.querySelectorAll('.app-animation-translate-y-start'),
            ...document.querySelectorAll('.app-animation-translate-x-start-right'),
            ...document.querySelectorAll('.app-animation-translate-x-start-left'),
            ...document.querySelectorAll('.app-animation-scale-start'),
            ...document.querySelectorAll('.app-animation-opacity-start'),
        ]
        const options = {
            root: null,
            threshold: 0.2
        }

        const observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("app-animation-end")
                    entry.target.classList.remove("app-animation-translate-y-start", "app-animation-translate-x-start-right", "app-animation-translate-x-start-left", "app-animation-scale-start", "app-animation-opacity-start", "app-animation-translate-y-start", "app-animation-translate-y-start")
                    observer.unobserve(entry.target);
                } else {
                    return;
                }
            });
        }, options);

        elements.forEach(element => observer.observe(element))
        return () => observer.disconnect();
    }, []);
}

export default useAnimation;